import styles from './IppicaInfoListItem.module.scss';

export type IppicaInfoListItemProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
  textType: 'small' | 'medium';
};

export const IppicaInfoListItem = ({ title, children, className, textType }: IppicaInfoListItemProps) => {
  return (
    <li className={`${styles.container} ${className ? className : ''}`}>
      {title && <span className={styles.title}>{title}</span>}
      <p className={`${styles.text} ${textType === 'small' ? styles.small : styles.medium}`}>{children}</p>
    </li>
  );
};
